<template>
    <ModalComponent name="editarInfo" @close="close">
        <div v-if="! editInfoPago">
            <div class="mb-3">
                <h3 class="text-center" v-if="!nueva_alta">{{ $t('perfil.confirmacion_info_pago') }}</h3>
                <p class="text-center">{{ $t('perfil.cobro_confirmacion') }}</p>
            </div>
            <div class="d-flex justify-content-end mt-5">
                <button class="btn btn-block btn-primary" @click="confirmarEdit">{{ $t('formularios.continuar') }}</button>
            </div>
        </div>
        <div v-else>
            <h3 class="text-center">{{ $t('perfil.introducir_tarjeta') }}</h3>
            <PagoPaycometComponent
                v-if="! loading"
                :jet_id="jet_id"
                :tid="tid"
                tipo_venta="editarInfoPago"
                @confirmacionTarjeta="close(true)"
            />
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from '@/components/backend/components/ModalComponent';
    import PagoPaycometComponent from '../compra/components/PagoPaycometComponent.vue';

    export default {
        props: ['tid', 'user_id', 'nueva_alta'],
        data() {
            return {
                editInfoPago: false,
                jet_id: null,
                loading: false
            }
        },
        methods: {
            close(exito = null) {
                if (exito) {
                    this.$toast.success('Información de pago actualizada');
                }

                this.editInfoPago = false;
                this.$emit('close');
            },
            confirmarEdit() {
                this.loading = true;

                const data = {
                    tid: this.tid,
                    user_id: this.$route.params.user_id ? this.$route.params.user_id : this.user_id,
                    filters: {}
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.get-jet-id'), data).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.loading = false;
                }).catch(e => { });

                this.editInfoPago = true;
            }
        },
        components: { ModalComponent, PagoPaycometComponent }
    }

</script>
